export default "__VITE_ASSET__2rIQNryl__"